import Meta from '@/utils/RouterMeta'
import Router from '@/utils/Router'

const child = [
    Router.instance({
        path: 'report',
        name: 'report',
        component: () => import('@/pages/report/test'),
        meta: Meta.instance({
            title: 'Общие',
            icon: 'mdi-cash-register',
            btnName: 'Общие',
            permissions: ['admin', 'moderator']
        })
    }),
    Router.instance({
        path: 'expense-chief-p',
        name: 'expense-chief-p',
        meta: Meta.instance({
            title: 'ПРИХОД для Главбух',
            icon: 'mdi-cash-plus',
            btnName: 'Общие',
            permissions: ['admin', 'moderator']
        })
    }),
    Router.instance({
        path: 'dashboard-daily',
        name: 'dashboard-daily',
        meta: Meta.instance({
            title: 'РАСХОД для Главбух',
            icon: 'mdi-cash-minus',
            btnName: 'РАСХОД для Главбух',
            permissions: ['admin', 'moderator']
        })
    }),
    Router.instance({
        path: 'expense-chief-accountant',
        name: 'expense-chief-accountant',
        component: () => import('@/pages/expenditure_chief_accountant/index'),
        meta: Meta.instance({
            title: 'Отчет Покупатель',
            icon: 'mdi-account-cash',
            btnName: 'Отчет Покупатель',
            permissions: ['admin', 'moderator']
        })
    }),
    Router.instance({
        path: 'report-contract',
        name: 'report-contract',
        component: () => import('@/pages/ReportContract/Contract'),
        meta: Meta.instance({
            title: 'Отчет Финансовый',
            icon: 'mdi-account-cash',
            btnName: 'Отчет Финансовый',
            permissions: ['admin', 'moderator']
        })
    }),
    Router.instance({
        path: 'dashboard-daily',
        name: 'dashboard-daily',
        meta: Meta.instance({
            title: 'Отчет Поставщик',
            icon: 'mdi-truck-check',
            btnName: 'Отчет Поставщик',
            permissions: ['admin', 'moderator']
        })
    }),
    Router.instance({
        path: 'dashboard-daily',
        name: 'dashboard-daily',
        meta: Meta.instance({
            title: 'Рабочие расчеты',
            icon: 'mdi-cash-refund',
            btnName: 'Отчет Поставщик',
            permissions: ['admin', 'moderator']
        })
    }),
    Router.instance({
        path: 'dashboard-daily',
        name: 'dashboard-daily',
        meta: Meta.instance({
            title: 'Отчет по прибыли',
            icon: 'mdi-cash-multiple',
            btnName: 'Отчет по прибыли',
            permissions: ['admin', 'moderator']
        })
    })
]

export const report = [
    Router.instance({
        meta: Meta.instance({
            icon: 'mdi-note',
            title: 'ОТЧЕТЫ',
            btnName: 'ОТЧЕТЫ',
            permissions: ['admin', 'moderator']
        }),
        children: child
    })
]
